function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import { Card as CardMUI, CardActionArea, CardActions, CardContent, Collapse, Drawer, Grid, List, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { mdiDotsVertical } from '@mdi/js';
import Icon from '@mdi/react';
import clsx from 'clsx';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { isNotEmptyOrNull } from '@tecsinapse/es-utils/build';
import { Divider, IconButton } from '@tecsinapse/ui-kit';
import { resolveData } from '../../utils/tableFunctions';
import { getActionButtons } from '../../Rows/RowActions/RowActions';
var useStyles = makeStyles(function (theme) {
  return {
    card: {
      maxWidth: 400,
      marginTop: theme.spacing(1),
      marginRight: theme.spacing(2),
      marginLeft: theme.spacing(2),
      marginBottom: theme.spacing(1)
    },
    size: {
      height: '1.5em'
    },
    cardAction: {
      display: 'block',
      textAlign: 'initial'
    },
    expand: {
      marginLeft: 'auto',
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      })
    },
    expandOpen: {
      transform: 'rotate(180deg)'
    },
    marginTop: {
      marginTop: theme.spacing(1)
    }
  };
});

var CardColumn = function CardColumn(_ref) {
  var title = _ref.title,
      customRender = _ref.customRender,
      data = _ref.data,
      field = _ref.field,
      tableHeaderHide = _ref.tableHeaderHide,
      classes = _ref.classes;
  return /*#__PURE__*/React.createElement("div", {
    key: field
  }, !tableHeaderHide && /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "textSecondary"
  }, title), /*#__PURE__*/React.createElement("div", null, customRender && data ? customRender(data) : /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle2",
    color: "textPrimary",
    className: tableHeaderHide ? classes.marginTop : ''
  }, resolveData(field, data))));
};

export var Card = function Card(_ref2) {
  var clearCache = _ref2.clearCache,
      updateList = _ref2.updateList,
      data = _ref2.data,
      columns = _ref2.columns,
      onRowClick = _ref2.onRowClick,
      actions = _ref2.actions,
      rowId = _ref2.rowId,
      labelShowLess = _ref2.labelShowLess,
      labelShowMore = _ref2.labelShowMore,
      tableHeaderHide = _ref2.tableHeaderHide;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isHidden = _useState4[0],
      setIsHidden = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      openActions = _useState6[0],
      setOpenActions = _useState6[1];

  var classes = useStyles();
  var paddingUnset = {
    padding: 'unset'
  };
  return /*#__PURE__*/React.createElement(CardMUI, {
    square: true,
    className: classes.card,
    key: rowId
  }, /*#__PURE__*/React.createElement(CardActionArea, {
    disableRipple: true,
    onClick: function onClick() {
      return onRowClick ? onRowClick(data) : null;
    }
  }, /*#__PURE__*/React.createElement(CardContent, null, /*#__PURE__*/React.createElement(Grid, {
    spacing: 1,
    direction: "column",
    container: true
  }, columns.map(function (_ref3, index) {
    var title = _ref3.title,
        field = _ref3.field,
        customRender = _ref3.customRender,
        _ref3$options = _ref3.options,
        options = _ref3$options === void 0 ? {} : _ref3$options;
    var _options$visible = options.visible,
        visible = _options$visible === void 0 ? true : _options$visible;
    var _options$hiddenCard = options.hiddenCard,
        hiddenCard = _options$hiddenCard === void 0 ? false : _options$hiddenCard;

    if (hiddenCard || !visible) {
      return null;
    }

    var displayFlex = {
      display: 'flex'
    };
    var flex1Auto = {
      flex: '1 1 auto'
    };
    var flex0AutoStart = {
      flex: '0 0 auto',
      alignSelf: 'flex-start'
    };
    var marginNegative = {
      marginRight: '-8px',
      marginTop: '-8px'
    };
    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      key: field
    }, /*#__PURE__*/React.createElement("div", {
      style: displayFlex
    }, /*#__PURE__*/React.createElement("div", {
      style: flex1Auto
    }, /*#__PURE__*/React.createElement(CardColumn, {
      title: title,
      customRender: customRender,
      data: data,
      field: field,
      tableHeaderHide: tableHeaderHide,
      classes: classes
    })), index === 0 && isNotEmptyOrNull(actions) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      style: flex0AutoStart
    }, /*#__PURE__*/React.createElement(IconButton, {
      "aria-label": "actions",
      style: marginNegative,
      onClick: function onClick(e) {
        e.stopPropagation();
        e.preventDefault();
        setOpenActions(true);
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      path: mdiDotsVertical,
      size: 1
    }))), /*#__PURE__*/React.createElement(Drawer, {
      anchor: "bottom",
      open: openActions,
      onClose: function onClose(e) {
        e.stopPropagation();
        e.preventDefault();
        setOpenActions(false);
      }
    }, /*#__PURE__*/React.createElement(List, {
      disablePadding: true
    }, getActionButtons(actions, true, data))))));
  })), /*#__PURE__*/React.createElement(Collapse, {
    className: classes.marginTop,
    "in": expanded,
    timeout: "auto",
    onEntered: updateList,
    onExited: function onExited() {
      updateList();
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    spacing: 1,
    direction: "column",
    container: true
  }, columns.map(function (_ref4) {
    var title = _ref4.title,
        field = _ref4.field,
        customRender = _ref4.customRender,
        _ref4$options = _ref4.options,
        options = _ref4$options === void 0 ? {} : _ref4$options;
    var _options$visible2 = options.visible,
        visible = _options$visible2 === void 0 ? true : _options$visible2;
    var _options$hiddenCard2 = options.hiddenCard,
        hiddenCard = _options$hiddenCard2 === void 0 ? false : _options$hiddenCard2;

    if (!hiddenCard || !visible) {
      return null;
    }

    if (!isHidden) {
      setIsHidden(true);
    }

    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      key: field
    }, /*#__PURE__*/React.createElement(CardColumn, {
      title: title,
      customRender: customRender,
      data: data,
      field: field
    }));
  }))))), isHidden && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, {
    variant: "solid"
  }), /*#__PURE__*/React.createElement(CardActions, {
    style: paddingUnset
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: function onClick() {
      clearCache();
      setExpanded(!expanded);
    },
    "aria-expanded": expanded,
    "aria-label": "Show more"
  }, /*#__PURE__*/React.createElement(ExpandMoreIcon, {
    color: "primary",
    className: clsx(classes.expand, _defineProperty({}, classes.expandOpen, expanded))
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "button",
    color: "textPrimary"
  }, expanded ? labelShowLess : labelShowMore)))));
};
export default Card;